import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { TableService } from '../../../domain/services/table.service';
import { ButtonComponent } from '../../../components/button/button.component';

@Component({
    selector: 'app-remove-tax',
    imports: [
        CommonModule,
        ButtonComponent,
    ],
    templateUrl: './remove-tax.component.html',
    styleUrl: './remove-tax.component.scss'
})
export class RemoveTaxComponent {
  constructor(
    private ngxSmartModalService: NgxSmartModalService, 
    private tableService: TableService,
  ) {}

  keepTax() {
    this.tableService.setRemoveTax(false);
    this.ngxSmartModalService.getModal('remove-tax-modal').close()
  }
  
  removeTax() {
    this.tableService.setRemoveTax(true);
    this.ngxSmartModalService.getModal('remove-tax-modal').close()
  }
}
